"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_USER = void 0;
var enums_1 = require("../enums");
exports.DEFAULT_USER = {
    photoURL: '',
    timezone: '',
    avatar: '',
    avgRate: 0,
    bidAmount: 0,
    countryCode: '',
    email: '',
    firebaseId: '',
    firstName: '',
    id: '',
    isEmailVerified: false,
    isPhoneVerified: false,
    lastName: '',
    phoneNumber: '',
    stripeCustomerId: '',
    stripeIdentityStatus: '',
    stripeUserId: '',
    userName: '',
    shippingInfo: [],
    totalRatings: 0,
    sellerFee: 7,
    profileDescription: '',
    acceptedTerms: false,
    credits: 0,
    awardedCreditToReferrer: false,
    debt: 0,
    payoutSchedule: enums_1.PayoutSchedule.ON_DELIVERY,
};
